import bridge from '@byted/ecom-mobile-lib/lib/bridge/index';
import env from './env';
bridge.config({ supports: () => true });

const createVisible = () => {
    if (env.appName === 'huoshan') {
        return listenJsbridge('H5_visible');
    }
    if (env.appName === 'douyin') {
        if (env.isAndroid) {
            return listenJsbridge('viewAppeared');
        } else {
            return listenJsbridge('notification', (data) => data.eventName === 'viewAppear');
        }
    }
    return listenJsbridge('visible');
};

function listenJsbridge(jsbridgeName: string, checkFn: (data?: any) => boolean = () => true) {
    return (cb: (data?: any) => unknown, jsonify = true) =>
        bridge.listen(jsbridgeName, (o: any) => {
            let data = o;
            if (jsonify && typeof o !== 'object') {
                try {
                    data = JSON.parse(o);
                } catch (e) {}
            }
            if (checkFn(data)) {
                cb && cb(data);
            }
        });
}

export const pageVisible = createVisible();

export default bridge;
